// import Topbar2 from "../../component/topbar2";
import "./hotText.css";
import {Row ,Col,Pagination} from "antd";
import React from 'react';

import { requestGet } from '../../component/functions';
import Topbar2 from "../../component/topbar2";
import BottomBanner from '../../bottombanner.js';


//公众号展示
class Artlist1 extends React.Component {
	constructor(){
		super();
		this.state={
			cutpage:1,
			totalpage:1,
			lvdcArr:[],
			src: "lydcgc",
			lydctitle: "lydcgc"
		}				
	}	
	// onsrcclick = (e, src) => {
	// 	this.setStates({
	// 		"src": src
	// 	});
	// 	this.requestHotFile(src, "1");
	// }
	
	//旅游地产
	componentDidMount(){
		this.requestHotFile(this.state.src, "1")		
	}
	//旅游地产
	requestHotFile=(src, intpage)=>{
		let that = this;
		let url = `https://gateway1.moxidata.cn/artical/artschema/?method=getartlistbycategory&src=${src}&intcutpage=${intpage}`;
				
		requestGet(url).then((data) => {
			// console.log(data);
			if(data.error===1){
				that.setState({
					lvdcArr:data.records,	
					cutpage:data.cutpage,
					totalpage:data.totalpage
				})
			}else{
				that.setState({		        
				    lvdcArr:[],
					cutpage:1,
					totalpage:1
				})
			}
		});
	}
	//切换公众号
	BtnClick = (e, src) => {
		// console.log(src);
		this.setState({
			"src": src,
			"lydctitle": src
		});
		this.requestHotFile(src, "1");
	}
	//页码
	
	changePage=(e)=>{
		console.log(e);
		this.requestHotFile(this.state.src, e);
	}

	render(){
	  const obj_stc = {
	  	"lydcgc": "旅游地产观察",
		"lj": "旅界"
	  };
	  let title_name = obj_stc[this.state.lydctitle];
	  // <span>{title_name}</span>
	  // <button onClick={(e) => this.BtnClick(e, "lydcgc")}>旅游地产观察</button>
	  // <button onClick={(e) => this.BtnClick(e, "lj")}>旅界</button>
	  return(
        <div style={{color:'white',overflow:'hidden'}} className="artkey-funbody">	
			<div style={{marginTop:'120px',}}>	
				<Row justify="center" align="middle" className="chapters">
					<img className="chapter-imgs" alt="" src={require("../../image/brands.png")}/>
					<span className="chapter-titles">公众号</span>				
				</Row>
				<Row justify="center" className="artlist-body1" onClick={(e) => this.BtnClick(e, "lydcgc")}>
					<Col span={12}><img className="art-coverimg1" alt="" src="https://app.moxidata.cn/college/content/imgs/www/lydc.jpeg" /></Col>
					<Col span={12} className="art-bodys">
						<h2 className="art-titles">旅游地产观察</h2>						
						<div style={{color:"#bbbbbb",bottom: "20px",position:"absolute",marginLeft:"15px"}}>聚焦文旅地产行业，为文旅科技赋能</div>
					</Col>
				</Row>		
			</div>
			
			 <div style={{marginTop:"50px"}}></div>
			 
			<div className="cooperation">
			 	<Row justify="center" align="middle" className="chapters">
			 		<img className="cooperation-imgs" alt="" src={require("../../image/brands.png")}/>
			 		<h2 className="cooperation-titles">合作公众号</h2>				
			 	</Row>
			 	<Row justify="center" className="artlist-body2" onClick={(e) => this.BtnClick(e, "lj")}>
			 		<Col span={12}><img className="art-coverimg2" alt="" src="https://app.moxidata.cn/college/content/imgs/www/lvjie.jpeg" /></Col>
				</Row>	
					<span className="cooperation-title">旅界</span>
			 </div>
			 <div style={{marginTop:"50px"}}></div>	
			<div>		  
				<Row justify="center" align="middle" className="chapters">
					<img alt="" className="chapter-imgs" src={require("../../image/brands.png")}/>
					<span className="chapter-titles">{title_name}</span>
				</Row>			 
					{this.state.lvdcArr.map((e,i)=>{
						return(
							<a href={e.url} key={e.artid} target="_blank" rel="noreferrer">
								<Row justify="center" className="artlist-bodys" >		
									<Col span={12}><img alt="" className="art-coverimgs" src={e.artimg__artlink} /></Col>
									<Col span={12} className="art-bodys">
										<div className="art-title2">{e.artname}</div>
										<div style={{ color:"#bbbbbb",position: 'absolute',bottom: '20px',marginLeft:'20px'}}>时间：{e.strdate.slice(0, 10)}</div>
									</Col>					
								</Row>
							</a>		
						)
					})
					}			
				{/* <div style={{marginTop:"30px"}}></div> */}
				<Pagination 
					className="page-sum"
					justify="center"
					defaultCurrent={this.state.cutpage}
					pageSize={6}
					total={this.state.totalpage*6}	
					onChange={this.changePage} 
					showSizeChanger={false}
				/>	
			</div>	
        </div>
	)} 
}
// 	

function Hottext(){
	return (
		<div className="moxi-page">
			<Topbar2 pagetitle="文旅热文" />
			{/* <div style={{marginTop:"90px"}}></div> */}
			<Artlist1/>		
			{/* <div style={{marginTop:"90px"}}></div> */}
			<BottomBanner style={{position:"absolute",top:"-30px"}}/>
		</div>
	)
}

export default Hottext

